module.exports = __webpack_public_path__ + "static/img/logowhite.9aaf1575.png";